import React, { useEffect, useRef, useState } from "react";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

export default function VonageSidebar(props) {
  const [streamSidebarOpen, setSidebarOpen] = useState(true);
  const [speakerIndex, setSpeakerIndex] = useState(0);
  useEffect(() => {
    // if(props.layoutMode != layoutMode){
    //   setLayoutMode(layoutMode);
    // }
  });

  function scrollSidebar(direction) {
    const { focusViewStreamsRef } = props;
    if (focusViewStreamsRef/* .current */ && focusViewStreamsRef/* .current */.children[0]) {
      const scrollTop = focusViewStreamsRef/* .current */.scrollTop;
      const margin = focusViewStreamsRef/* .current */.children[0].getBoundingClientRect().height * 0.02;
      const childHeight = focusViewStreamsRef/* .current */.children[0].getBoundingClientRect().height + margin;
  
      if (direction == "up") {
        if (speakerIndex > 1) {
          setSpeakerIndex(speakerIndex - 1);
          focusViewStreamsRef/* .current */.style.transform = `translateY(${(speakerIndex - 1) * (scrollTop - childHeight)}px)`;
        } else if (speakerIndex == 1) {
          setSpeakerIndex(0);
          focusViewStreamsRef./* .current */style.transform = `translateY(0px)`;
        }
      }
      if (direction == "down") {
        if (speakerIndex < props.streams.length - 1) {
          focusViewStreamsRef/* .current */.style.transform = `translateY(${(speakerIndex == 0 ? 1 : speakerIndex + 1) * (scrollTop - childHeight)}px)`;
          setSpeakerIndex(speakerIndex + 1);
        }
      }
    }
  }
  return (
    <div id="vonage-subscribed-streams" style={{ display: props.streams.length > 1 && !props.screenshareStream ? "block" : "none", left: streamSidebarOpen ? "1%" : "-19%" }}>
      <span className={"vonage-subscribed-streams-arrow" + (speakerIndex == 0 ? " disabled" : "")} id="vonage-subscribed-streams-arrow-up" onClick={() => scrollSidebar("up")}>
        <KeyboardArrowUpIcon />
      </span>
      <span
        className={"vonage-subscribed-streams-arrow" + (speakerIndex == props.streams.length - 1 ? " disabled" : "")}
        id="vonage-subscribed-streams-arrow-down"
        onClick={() => scrollSidebar("down")}
      >
        <KeyboardArrowDownIcon />
      </span>
      <span id="vonage-subscribed-streams-toggler" style={{ left: streamSidebarOpen ? "-2%" : null, right: !streamSidebarOpen ? "-10%" : null }} onClick={() => setSidebarOpen(!streamSidebarOpen)}>
        {streamSidebarOpen ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
      </span>
      <div ref={(r) => props.setfocusViewStreamsRef(r)} id="vonage-subscribed-streams-container"></div>
    </div>
  );
}
